import { Assets } from "../../assets";
import { titleJson } from "../copysInformation";
import { typeNameCard } from "../typeTexture";

export const menuSelect = {
	principal: 0,
	secondary: 1,
	third: 2,
};

export const modalInformation = {
	name: "",
	nameTitle: "",
	icon: Assets.icon.building,
	background: Assets.texture.casa,
	description: null,
	learnMore: [
		{
			image: Assets.backgrounds.bibloteca.bb1,
		},
		{
			image: Assets.backgrounds.cafeteria.bc1,
		},
	],
};

export const baseJson = {
	id: 0,
	name: "n/a",
	background: Assets.texture.casa,
	menuSelect: menuSelect.secondary,
	icon: Assets.icon.building,
	sphereView: Assets.texture.casa,
	children: [],
	findCopyInformation: "",
	modalInformation,
	hotspot: Assets.hotspot.move,
	hotspotHover: Assets.hotspot.move,
	moveHotSpot: Assets.texture.cafeteria.c1,
	position: {
		x: -4,
		y: 1,
		z: 1.6,
	},
	camarePosition: {
		x: -0.036,
		y: 0.362,
		z: -0.932,
	},
	moveHotSpotArrow: [],
};

const childClaustro = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.claustro.bcl1,
		findCopyInformation: titleJson.rectoria,
		moveHotSpot: Assets.texture.claustro.cl1,
		camarePosition: {
			x: -0.277,
			y: 0.124,
			z: 0.953,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: 2,
					y: 0.2,
					z: -8.67,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.claustro.bcl2,
		findCopyInformation: titleJson.rectoria,
		moveHotSpot: Assets.texture.claustro.cl2,
		camarePosition: {
			x: 0.61,
			y: 0.075,
			z: -0.789,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: -4,
					y: 0.2,
					z: 6.77,
				},
			},
		],
	},
];

const childCentroCultura = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.centro_cultura.bcc2,
		findCopyInformation: titleJson.culturalCenter,
		moveHotSpot: Assets.texture.centro_cultura.cc2,
		camarePosition: {
			x: 0.594,
			y: 0.203,
			z: 0.778,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: -4,
					y: 0.2,
					z: -8.67,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.centro_cultura.bcc1,
		findCopyInformation: titleJson.culturalCenter,
		moveHotSpot: Assets.texture.centro_cultura.cc1,
		camarePosition: {
			x: 0.719,
			y: 0.203,
			z: -0.665,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: -4,
					y: 0.2,
					z: 4.57,
				},
			},
		],
	},
];

const childEspacioSonoro = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.espacio_sonoro.bes3,
		findCopyInformation: titleJson.soundSpace,
		moveHotSpot: Assets.texture.espacio_sonoro.es3,
		camarePosition: {
			x: 0.64,
			y: 0.065,
			z: 0.765,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: -4,
					y: 0.2,
					z: -6.46,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.espacio_sonoro.bes2,
		findCopyInformation: titleJson.soundSpace,
		moveHotSpot: Assets.texture.espacio_sonoro.es2,
		camarePosition: {
			x: 0.864,
			y: 0.038,
			z: 0.503,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: -9,
					y: 0.2,
					z: -6.46,
				},
			},
		],
	},
];

const childJardinEden = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.jardin_eden.bje1,
		findCopyInformation: titleJson.gardenEden,
		moveHotSpot: Assets.texture.jardin_eden.je1,
		camarePosition: {
			x: 0.206,
			y: 0.131,
			z: -0.949,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: -9,
					y: 0.2,
					z: 20.01,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.jardin_eden.bje2,
		findCopyInformation: titleJson.gardenEden,
		moveHotSpot: Assets.texture.jardin_eden.je2,
		camarePosition: {
			x: -0.797,
			y: 0.11,
			z: -0.594,
		},
		moveHotSpotArrow: [
			{
				id: 2,
				position: {
					x: 13,
					y: 0.2,
					z: 8.89,
				},
			},
		],
	},
	{
		...baseJson,
		id: 2,
		background: Assets.backgrounds.jardin_eden.bje3,
		findCopyInformation: titleJson.gardenEden,
		moveHotSpot: Assets.texture.jardin_eden.je3,
		camarePosition: {
			x: 0.465,
			y: 0.216,
			z: -0.858,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: -6,
					y: 0.2,
					z: 8.89,
				},
			},
		],
	},
];

const childJardinPicNic = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.jardin_picnic.bjp1,
		findCopyInformation: titleJson.gardenPicNic,
		moveHotSpot: Assets.texture.jardin_picnic.jp1,
		camarePosition: {
			x: 0.711,
			y: 0.208,
			z: 0.675,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: -9,
					y: 1,
					z: -10.87,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.jardin_picnic.bjp3,
		findCopyInformation: titleJson.gardenPicNic,
		moveHotSpot: Assets.texture.jardin_picnic.jp3,
		camarePosition: {
			x: -0.934,
			y: 0.157,
			z: 0.322,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: 8,
					y: 1,
					z: -5.16,
				},
			},
		],
	},
];

const childBibloteca = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.bibloteca.bb3,
		findCopyInformation: titleJson.library,
		moveHotSpot: Assets.texture.bibloteca.b3,
		camarePosition: {
			x: 0.987,
			y: 0.038,
			z: 0.155,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: 7,
					y: 0.2,
					z: -6.46,
				},
			},
			{
				id: 2,
				position: {
					x: -10,
					y: -1,
					z: -1,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.bibloteca.bb4,
		findCopyInformation: titleJson.library,
		moveHotSpot: Assets.texture.bibloteca.b4,
		camarePosition: {
			x: -0.539,
			y: 0.019,
			z: -0.842,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: 7,
					y: 0.2,
					z: 4.57,
				},
			},
		],
	},
	{
		...baseJson,
		id: 2,
		background: Assets.backgrounds.bibloteca.bb1,
		findCopyInformation: titleJson.library,
		moveHotSpot: Assets.texture.bibloteca.b1,
		camarePosition: {
			x: 0.895,
			y: 0.025,
			z: -0.445,
		},
		moveHotSpotArrow: [
			{
				id: 3,
				position: {
					x: -10,
					y: 1,
					z: 0.6,
				},
			},
		],
	},
	{
		...baseJson,
		id: 3,
		background: Assets.backgrounds.bibloteca.bb2,
		findCopyInformation: titleJson.library,
		moveHotSpot: Assets.texture.bibloteca.b2,
		camarePosition: {
			x: -0.927,
			y: -0.015,
			z: -0.375,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: 8,
					y: 0.2,
					z: 4.57,
				},
			},
		],
	},
];

const childCafeteria = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.cafeteria.bc1,
		findCopyInformation: titleJson.cafeteria,
		moveHotSpot: Assets.texture.cafeteria.c1,
		camarePosition: {
			x: -0.928,
			y: 0.164,
			z: 0.334,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: 16,
					y: 4.6,
					z: -4.57,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.cafeteria.bc3,
		findCopyInformation: titleJson.cafeteria,
		moveHotSpot: Assets.texture.cafeteria.c3,
		camarePosition: {
			x: 0.993,
			y: 0.065,
			z: -0.103,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: -10,
					y: 1,
					z: 0.6,
				},
			},
		],
	},
];

const childActividadesDeportivas = [
	{
		...baseJson,
		id: 0,
		background: Assets.backgrounds.actividades_deportivas.bad1,
		findCopyInformation: titleJson.sportActivities,
		moveHotSpot: Assets.texture.actividades_deportivas.ad1,
		camarePosition: {
			x: 0.908,
			y: 0.216,
			z: -0.358,
		},
		moveHotSpotArrow: [
			{
				id: 1,
				position: {
					x: -11,
					y: -2.1,
					z: 6.77,
				},
			},
		],
	},
	{
		...baseJson,
		id: 1,
		background: Assets.backgrounds.actividades_deportivas.bad3,
		findCopyInformation: titleJson.sportActivities,
		moveHotSpot: Assets.texture.actividades_deportivas.ad3,
		camarePosition: {
			x: -0.9,
			y: 0.131,
			z: 0.415,
		},
		moveHotSpotArrow: [
			{
				id: 2,
				position: {
					x: 13,
					y: -2.1,
					z: -2.05,
				},
			},
		],
	},
	{
		...baseJson,
		id: 2,
		background: Assets.backgrounds.actividades_deportivas.bad4,
		findCopyInformation: titleJson.sportActivities,
		moveHotSpot: Assets.texture.actividades_deportivas.ad4,
		camarePosition: {
			x: 0.381,
			y: 0.206,
			z: 0.902,
		},
		moveHotSpotArrow: [
			{
				id: 0,
				position: {
					x: -6,
					y: -2.1,
					z: -15.29,
				},
			},
		],
	},
];

// const childrenPlane = [
// 	{
// 		...baseJson,
// 	},
// ];

const school = [
	{
		...baseJson,
		id: 0,
		name: typeNameCard.center_cultural,
		icon: Assets.icon.life,
		background: Assets.backgrounds.centro_cultura.bcc1,
		hotspot: Assets.hotspot.hCentro,
		hotspotHover: Assets.hotspot.hover.hCentroHover,
		children: childCentroCultura,
		position: {
			x: -15.285,
			y: -4.256,
			z: 2.361,
		},
	},
	{
		...baseJson,
		id: 1,
		icon: Assets.icon.life,
		name: typeNameCard.claustro,
		background: Assets.backgrounds.claustro.bcl1,
		hotspot: Assets.hotspot.hclaustro,
		hotspotHover: Assets.hotspot.hover.hclaustroHover,
		children: childClaustro,
		position: {
			x: 11.184,
			y: -1.051,
			z: 2.361,
		},
	},
	{
		...baseJson,
		id: 2,
		name: typeNameCard.sound_space,
		icon: Assets.icon.life,
		hotspot: Assets.hotspot.hespacio,
		hotspotHover: Assets.hotspot.hover.hespacioHover,
		background: Assets.backgrounds.espacio_sonoro.bes1,
		children: childEspacioSonoro,
		position: {
			x: 13,
			y: -4.6,
			z: 0.14,
		},
	},
	{
		...baseJson,
		id: 3,
		name: typeNameCard.library,
		icon: Assets.icon.life,
		background: Assets.backgrounds.bibloteca.bb3,
		hotspot: Assets.hotspot.hbibloteca,
		hotspotHover: Assets.hotspot.hover.hbiblotecaHover,
		children: childBibloteca,
		position: {
			x: -12.491,
			y: -4.462,
			z: 0.051,
		},
	},
];

const installations = [
	{
		...baseJson,
		id: 0,
		name: typeNameCard.gardenEden,
		background: Assets.backgrounds.jardin_eden.bje1,
		icon: Assets.icon.installations,
		hotspot: Assets.hotspot.heden,
		hotspotHover: Assets.hotspot.hover.hedenHover,
		children: childJardinEden,
		position: {
			x: 11,
			y: -8.7,
			z: 8.96,
		},
	},
	{
		...baseJson,
		id: 1,
		icon: Assets.icon.installations,
		name: typeNameCard.gardenPicNic,
		hotspot: Assets.hotspot.hjardinpic,
		hotspotHover: Assets.hotspot.hover.hjardinpicHover,
		background: Assets.backgrounds.jardin_picnic.bjp1,
		children: childJardinPicNic,
		position: {
			x: 16,
			y: -3.9,
			z: -2.5,
		},
	},
	{
		...baseJson,
		id: 2,
		icon: Assets.icon.installations,
		name: typeNameCard.cafeteria,
		hotspot: Assets.hotspot.hcafeteria,
		hotspotHover: Assets.hotspot.hover.hcafeteriaHover,
		background: Assets.backgrounds.cafeteria.bc1,
		children: childCafeteria,
		position: {
			x: -12,
			y: -10.874,
			z: -1.051,
		},
	},
	{
		...baseJson,
		id: 3,
		icon: Assets.icon.installations,
		name: typeNameCard.sportActive,
		hotspot: Assets.hotspot.hactividades,
		hotspotHover: Assets.hotspot.hover.hactividadesHover,
		children: childActividadesDeportivas,
		background: Assets.backgrounds.actividades_deportivas.bad1,
		position: {
			x: -14,
			y: -4.3,
			z: 6.77,
		},
	},
];

export const menuSeparateMenus = [
	{
		...baseJson,
		id: 0,
		name: "Vida estudiantil",
		background: Assets.backgrounds.jardin_eden.bje1,
		children: school,
		icon: Assets.icon.life,
	},
	{
		...baseJson,
		id: 1,
		name: "Instalaciones",
		children: installations,
		background: Assets.backgrounds.claustro.bcl1,
		icon: Assets.icon.installations,
	},
];

export const menuBack = {
	id: menuSelect.principal,
	data: menuSeparateMenus,
};
